<template>
    <li style="width: max-content;">
        <slot/>
    </li>
    <li v-if="!last" class="ms-2 me-2">
       /
    </li>
</template>

<script>
    export default {
        props: {
            last: { type: Boolean, default: false }
        }
    }
</script>
